import type { ColorNames } from '@packages/styles/colors';

export default function color(color: ColorNames): `var(--color-${ColorNames})` {
    return `var(--color-${color})`;
}

export const isHex = (hex: string): boolean => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);
